/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type CreateUserOnboardingRequestDTO = {
    confirmPasscode?: string;
    countryCode?: string;
    passcode?: string;
    phoneNumber?: string;
    purpose?: CreateUserOnboardingRequestDTO.purpose;
};

export namespace CreateUserOnboardingRequestDTO {

    export enum purpose {
        CUSTOMER_SIGN_UP = 'CUSTOMER_SIGN_UP',
        NON_CUSTOMER_SIGN_UP = 'NON_CUSTOMER_SIGN_UP',
    }


}

